export default __webpack_public_path__ + "static/media/RedHatDisplay-Bold.2ec0c3da.ttf";